import React from 'react'
import styles from '../app_info.module.css'
import strings from '../../../strings/strings.json'

export default function CertificateMapper(props) {

    const objectMapper = (key, index) => {

        return (
            <div style={{ display: "flex" }} key={index}>
                <span className={`${styles.certificate_mapper_key} englishIranSans`}>{keyHandler(key)}</span>
                <span className={`${styles.certificate_mapper_value} englishIranSans`}>{props.data[key]}</span>
            </div>
        )
    }

    const keyHandler = (key) => {
        switch (key) {
            case "ExpireDate":
                return strings.fileDetail_expireDate
            case "Issuer":
                return strings.fileDetail_issuer
            case "SHA256":
                return strings.general_sha256
            case "SHA1":
                return strings.fileDetail_sha1


            default:
                break;
        }
    }

    return (
        <div>{Object.keys(props.data).map(objectMapper)}</div>
    )
}